// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"1f9a3942","787":"7072ad4d"}[chunkId] + ".chunk.js";
};